import { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';

const PROJECTS = [
  {
    id: 'd1',
    title: 'Chaka Ride',
    tag: 'Car Rental Platform',
    category: 'Business Website',
    status: 'Demo',
    color: '#2563eb',
    year: '2025',
    thumbnail: 'https://res.cloudinary.com/dycrowzen/image/upload/v1774970424/chaka-ride_lheml0.png',
    desc: 'Professional car rental website with service pages, contact flow, custom branding, language support, and responsive layouts.',
    stack: ['Next.js', 'React', 'Node.js', 'Express.js', 'Tailwind CSS', 'Framer Motion'],
    results: ['Multi-language support', 'Responsive customer journey', 'Smooth page transitions'],
    liveUrl: 'https://chaka-ride.vercel.app/en',
    featured: false,
  },
  {
    id: 'd2',
    title: 'LuxeCraft',
    tag: 'E-commerce Store',
    category: 'E-commerce',
    status: 'Demo',
    color: '#d97706',
    year: '2025',
    thumbnail: 'https://res.cloudinary.com/dwrlbuej9/image/upload/v1775034833/demo-ecommerce_h9hkpn.png',
    desc: 'Complete e-commerce experience with listings, filtering, search, cart, checkout, and payment gateway integration.',
    stack: ['React', 'Node.js', 'MongoDB', 'Stripe'],
    results: ['Advanced product filtering', 'Secure Stripe checkout', 'Mobile-first storefront'],
    liveUrl: 'https://demo-com2.vercel.app/',
    featured: false,
  },
  {
    id: 'd3',
    title: 'FoodExpress',
    tag: 'Food Delivery',
    category: 'Food & Delivery',
    status: 'Demo',
    color: '#e11d48',
    year: '2026',
    thumbnail: 'https://res.cloudinary.com/dnc1uozna/image/upload/v1775070146/food_xpress_banner_rh24wx.png',
    desc: 'High-performance food delivery platform with restaurant discovery, live filtering, and a polished menu experience.',
    stack: ['Next.js 14', 'React', 'Tailwind CSS', 'Framer Motion', 'TypeScript'],
    results: ['Dynamic restaurant explorer', 'Premium micro-interactions', 'Type-safe build'],
    liveUrl: 'https://food-xpress-gules.vercel.app',
    featured: false,
  },
  {
    id: 'd4',
    title: 'Employee Management System',
    tag: 'Operations Platform',
    category: 'Custom System',
    status: 'Demo',
    color: '#dc2626',
    year: '2025',
    thumbnail: 'https://res.cloudinary.com/dwrlbuej9/image/upload/v1775050560/Screenshot_2026-04-01_193524_ym6qrg.png',
    desc: 'Employee profiles, attendance, leave management, performance reviews, location tracking, and admin workflows in one system.',
    stack: ['React', 'Node.js', 'MongoDB', 'Google Maps API'],
    results: ['Live location tracking', 'Automated leave workflow', 'Role-based portals'],
    liveUrl: 'https://employee-management-system-ten-orcin-74.vercel.app/dashboard',
    featured: false,
  },
  {
    id: 'd5',
    title: 'Foodashh',
    tag: 'Delivery Service',
    category: 'Food & Delivery',
    status: 'Demo',
    color: '#0891b2',
    year: '2025',
    thumbnail: 'https://res.cloudinary.com/dwrlbuej9/image/upload/v1775050862/Screenshot_2026-04-01_194012_dedz9l.png',
    desc: 'Food delivery service with restaurants, menus, order placement, real-time order tracking, payment, and admin dashboard.',
    stack: ['React', 'Node.js', 'MongoDB', 'Stripe', 'JWT'],
    results: ['Real-time order status', 'Secure JWT authentication', 'Payment-ready checkout'],
    liveUrl: 'https://foodashh.vercel.app/',
    featured: false,
  },
  {
    id: 'd6',
    title: 'Foodash POS',
    tag: 'Restaurant POS',
    category: 'Custom System',
    status: 'Demo',
    color: '#0f766e',
    year: '2025',
    thumbnail: 'https://res.cloudinary.com/dwrlbuej9/image/upload/v1775052627/download_yyfjyh.png',
    desc: 'Restaurant point-of-sale system for managing orders, tables, inventory, payments, and sales analytics.',
    stack: ['React', 'Node.js', 'MongoDB', 'Stripe', 'JWT'],
    results: ['Table-wise order management', 'Inventory alerts', 'Sales analytics'],
    liveUrl: 'https://foodashhpos.vercel.app/',
    featured: false,
  },
  {
    id: 'd7',
    title: 'WP Accelerate',
    tag: 'WordPress Optimization',
    category: 'SaaS',
    status: 'Demo',
    color: '#7c3aed',
    year: '2025',
    thumbnail: 'https://res.cloudinary.com/dwrlbuej9/image/upload/v1775053161/wp_jq6w3v.png',
    desc: 'Optimization and monitoring dashboard for WordPress sites with uptime, backups, restore actions, and site health visibility.',
    stack: ['React', 'Node.js', 'MongoDB', 'Stripe'],
    results: ['Uptime monitoring', 'Scheduled backups', 'Site health dashboard'],
    liveUrl: 'https://wp-shield-pi.vercel.app/',
    featured: false,
  },
  {
    id: 'd8',
    title: 'Video Agency',
    tag: 'Agency Dashboard',
    category: 'SaaS',
    status: 'Demo',
    color: '#9333ea',
    year: '2025',
    thumbnail: 'https://res.cloudinary.com/dwrlbuej9/image/upload/v1775049937/demo-video-agency_t5w0yu.png',
    desc: 'Production agency portal with project management, client updates, sales analytics, and inventory workflows.',
    stack: ['React', 'Chart.js', 'Node.js', 'MongoDB', 'JWT'],
    results: ['Client project portal', 'Sales dashboard', 'Asset tracking'],
    liveUrl: 'https://vagencys.vercel.app/',
    featured: false,
  },
  {
    id: 'd9',
    title: 'USA Travel Guru',
    tag: 'Travel Agency',
    category: 'Travel',
    status: 'Live',
    color: '#2563eb',
    year: '2025',
    thumbnail: 'https://res.cloudinary.com/dwrlbuej9/image/upload/v1775646905/Screenshot_2026-04-08_170919_w8jurr.png',
    desc: 'Travel agency website with booking flows, package management, client portal, and operational dashboard features.',
    stack: ['React', 'Chart.js', 'Node.js', 'MongoDB', 'JWT'],
    results: ['Online booking system', 'Client booking portal', 'Revenue analytics'],
    liveUrl: 'https://usatravelguru.com/',
    featured: true,
  },
  {
    id: 'd10',
    title: 'Tours USA',
    tag: 'Travel Booking',
    category: 'Travel',
    status: 'Live',
    color: '#be185d',
    year: '2025',
    thumbnail: 'https://res.cloudinary.com/dwrlbuej9/image/upload/v1775647274/Screenshot_2026-04-08_172050_kp9p2l.png',
    desc: 'USA-based travel platform with tour listings, booking management, customer records, and admin analytics.',
    stack: ['React', 'Chart.js', 'Node.js', 'MongoDB', 'JWT'],
    results: ['Package listing flow', 'Booking admin system', 'Sales reporting'],
    liveUrl: 'https://www.tours-usa.com/',
    featured: true,
  },
  {
    id: 'd11',
    title: 'USA Guided Tours',
    tag: 'Tours Platform',
    category: 'Travel',
    status: 'Live',
    color: '#475569',
    year: '2025',
    thumbnail: 'https://res.cloudinary.com/dwrlbuej9/image/upload/v1775653685/Screenshot_2026-04-08_190644_nsii53.png',
    desc: 'Guided tour website with itinerary browsing, booking requests, client account experience, and admin scheduling.',
    stack: ['React', 'Chart.js', 'Node.js', 'MongoDB', 'JWT'],
    results: ['Tour browsing', 'Itinerary management', 'Admin scheduling'],
    liveUrl: 'https://usaguidedtours.com/',
    featured: true,
  },
  {
    id: 'd12',
    title: 'Cosmos Holiday',
    tag: 'Travel Agency',
    category: 'Travel',
    status: 'Live',
    color: '#059669',
    year: '2025',
    thumbnail: 'https://res.cloudinary.com/dwrlbuej9/image/upload/v1775874281/Screenshot_2026-04-11_082119_whfwkk.png',
    desc: 'Bangladesh-based travel website with local and international tour package booking, customer portal, and analytics.',
    stack: ['React', 'Chart.js', 'Node.js', 'MongoDB', 'JWT'],
    results: ['Tour package booking', 'Trip history tracking', 'Booking analytics'],
    liveUrl: 'https://cosmosholiday.com/',
    featured: true,
  },
  {
    id: 'd13',
    title: 'Site Monitor',
    tag: 'Security SaaS',
    category: 'SaaS',
    status: 'Live',
    color: '#dc2626',
    year: '2025',
    thumbnail: 'https://res.cloudinary.com/dwrlbuej9/image/upload/v1776311265/Screenshot_2026-04-16_094424_wtr6is.png',
    desc: 'Website security monitoring service with uptime checks, automated backups, restoration actions, and subscription billing.',
    stack: ['React', 'Node.js', 'MongoDB', 'Stripe'],
    results: ['Live uptime monitoring', 'Automated backups', 'Stripe subscriptions'],
    liveUrl: 'https://SiteMonitor-guardian.lovable.app/',
    featured: true,
  },
  {
    id: 'd14',
    title: 'Local Service Provider',
    tag: 'Service Platform',
    category: 'Service Marketplace',
    status: 'Live',
    color: '#0891b2',
    year: '2025',
    thumbnail: 'https://res.cloudinary.com/dwrlbuej9/image/upload/v1776134419/Screenshot_2026-04-14_083936_kommbq.png',
    desc: 'Local service provider platform with booking, job status tracking, project workflows, and business performance analytics.',
    stack: ['React', 'Chart.js', 'Node.js', 'MongoDB', 'JWT'],
    results: ['Service booking portal', 'Job status tracking', 'Business reporting'],
    liveUrl: 'https://localserviceprovider.com/',
    featured: true,
  },
];

const CATEGORIES = ['All', ...Array.from(new Set(PROJECTS.map((project) => project.category)))];
const STACKS = ['All', ...Array.from(new Set(PROJECTS.flatMap((project) => project.stack)))].slice(0, 15);

const PROCESS = [
  { step: '01', title: 'Scope the outcome', desc: 'We define the customer journey, data model, integrations, and launch target before design starts.' },
  { step: '02', title: 'Design the workflow', desc: 'Screens, states, and admin flows are shaped around real business operations, not decoration.' },
  { step: '03', title: 'Build in releases', desc: 'We ship in stages, review with you, and keep quality checks tied to every delivery milestone.' },
  { step: '04', title: 'Launch and support', desc: 'Deployment, handover, training, and post-launch support are included in the project rhythm.' },
];

function ProjectModal({ project, onClose }) {
  useEffect(() => {
    if (!project) return undefined;

    const onKeyDown = (event) => {
      if (event.key === 'Escape') onClose();
    };

    document.addEventListener('keydown', onKeyDown);
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = '';
    };
  }, [onClose, project]);

  if (!project) return null;

  return (
    <div
      role="presentation"
      onClick={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        background: 'rgba(15,23,42,0.72)',
        backdropFilter: 'blur(10px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 18,
        overflowY: 'auto',
      }}
    >
      <div
        style={{
          width: 'min(980px, 100%)',
          maxHeight: '92vh',
          overflowY: 'auto',
          background: '#fff',
          borderRadius: 8,
          border: '1px solid rgba(255,255,255,0.24)',
          boxShadow: '0 40px 90px rgba(15,23,42,0.35)',
        }}
      >
        <div style={{ display: 'grid', gridTemplateColumns: '1.05fr 0.95fr' }} className="modal-layout">
          <div style={{ minHeight: 360, background: '#f1f5f9' }}>
            <img
              src={project.thumbnail}
              alt={project.title}
              style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
            />
          </div>
          <div style={{ padding: '30px clamp(22px, 4vw, 38px)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 18, alignItems: 'flex-start', marginBottom: 20 }}>
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                <span className="status-pill" style={{ color: project.color, borderColor: `${project.color}45`, background: `${project.color}10` }}>
                  {project.status}
                </span>
                <span className="status-pill">{project.year}</span>
              </div>
              <button
                aria-label="Close project details"
                onClick={onClose}
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: 8,
                  border: '1px solid var(--border)',
                  background: '#fff',
                  color: 'var(--muted)',
                  fontSize: 18,
                }}
              >
                x
              </button>
            </div>

            <div style={{ color: project.color, fontSize: 12, fontFamily: 'var(--font-m)', fontWeight: 800, textTransform: 'uppercase', marginBottom: 10 }}>
              {project.tag}
            </div>
            <h2 style={{ fontFamily: 'var(--font-h)', fontSize: 'clamp(26px, 4vw, 40px)', lineHeight: 1.05, color: 'var(--text)', margin: '0 0 16px', fontWeight: 900 }}>
              {project.title}
            </h2>
            <p style={{ color: 'var(--muted)', fontSize: 15, lineHeight: 1.75, marginBottom: 24 }}>
              {project.desc}
            </p>

            <div style={{ marginBottom: 24 }}>
              <div className="detail-label">Key Results</div>
              <div style={{ display: 'grid', gap: 10 }}>
                {project.results.map((result) => (
                  <div key={result} style={{ display: 'flex', gap: 10, color: 'var(--text)', fontSize: 14, lineHeight: 1.5 }}>
                    <span style={{ color: project.color, fontWeight: 900 }}>-</span>
                    <span>{result}</span>
                  </div>
                ))}
              </div>
            </div>

            <div style={{ marginBottom: 28 }}>
              <div className="detail-label">Stack</div>
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                {project.stack.map((item) => (
                  <span key={item} className="tech-pill">{item}</span>
                ))}
              </div>
            </div>

            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
              <a href={project.liveUrl} target="_blank" rel="noreferrer" className="btn-primary" style={{ padding: '13px 24px' }}>
                Visit Project -&gt;
              </a>
              <Link to="/contact" className="btn-outline" style={{ padding: '13px 22px' }}>
                Build Similar
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function ProjectCard({ project, onSelect }) {
  return (
    <article className="project-card">
      <button
        type="button"
        onClick={() => onSelect(project)}
        style={{
          display: 'block',
          width: '100%',
          border: 0,
          padding: 0,
          background: 'transparent',
          textAlign: 'left',
        }}
      >
        <div className="project-image-wrap">
          <img src={project.thumbnail} alt={project.title} className="project-image" loading="lazy" />
          <div className="project-shade" />
          <div className="project-meta">
            <span>{project.status}</span>
            <span>{project.year}</span>
          </div>
        </div>
        <div style={{ padding: 22 }}>
          <div style={{ color: project.color, fontSize: 12, fontFamily: 'var(--font-m)', fontWeight: 800, textTransform: 'uppercase', marginBottom: 10 }}>
            {project.tag}
          </div>
          <h3 style={{ fontFamily: 'var(--font-h)', fontSize: 22, lineHeight: 1.15, color: 'var(--text)', margin: '0 0 12px', fontWeight: 900 }}>
            {project.title}
          </h3>
          <p style={{ color: 'var(--muted)', fontSize: 14, lineHeight: 1.65, marginBottom: 18 }}>
            {project.desc}
          </p>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 20 }}>
            {project.stack.slice(0, 4).map((item) => (
              <span key={item} className="tech-pill">{item}</span>
            ))}
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16, alignItems: 'center', paddingTop: 16, borderTop: '1px solid var(--border)' }}>
            <span style={{ fontSize: 13, color: 'var(--text)', fontWeight: 800 }}>View case</span>
            <span style={{ color: project.color, fontWeight: 900 }}>-&gt;</span>
          </div>
        </div>
      </button>
    </article>
  );
}

export default function PortfolioPage() {
  const [category, setCategory] = useState('All');
  const [stack, setStack] = useState('All');
  const [search, setSearch] = useState('');
  const [selectedProject, setSelectedProject] = useState(null);

  const featured = PROJECTS.find((project) => project.featured) || PROJECTS[0];

  const filteredProjects = useMemo(() => {
    const query = search.trim().toLowerCase();

    return PROJECTS.filter((project) => {
      const matchesCategory = category === 'All' || project.category === category;
      const matchesStack = stack === 'All' || project.stack.includes(stack);
      const matchesSearch = !query || [project.title, project.tag, project.category, project.status, project.desc, ...project.stack]
        .join(' ')
        .toLowerCase()
        .includes(query);

      return matchesCategory && matchesStack && matchesSearch;
    });
  }, [category, search, stack]);

  return (
    <div style={{ overflowX: 'hidden', background: 'var(--bg)' }}>
      <style>{`
        @keyframes fadeUp { from { opacity: 0; transform: translateY(18px); } to { opacity: 1; transform: none; } }
        @keyframes slideMarquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }

        .portfolio-shell { max-width: 1180px; margin: 0 auto; padding: 0 5%; }
        .portfolio-label {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          color: var(--teal);
          font-family: var(--font-m);
          font-size: 12px;
          font-weight: 800;
          letter-spacing: 1.5px;
          text-transform: uppercase;
          margin-bottom: 18px;
        }
        .portfolio-label::before {
          content: '';
          width: 28px;
          height: 2px;
          border-radius: 99px;
          background: var(--teal);
        }
        .status-pill,
        .tech-pill {
          display: inline-flex;
          align-items: center;
          min-height: 28px;
          padding: 6px 10px;
          border-radius: 8px;
          border: 1px solid var(--border);
          background: #fff;
          color: var(--muted);
          font-size: 12px;
          font-weight: 700;
        }
        .tech-pill { font-size: 11px; font-family: var(--font-m); }
        .filter-button {
          min-height: 38px;
          padding: 9px 14px;
          border-radius: 8px;
          border: 1px solid var(--border);
          background: #fff;
          color: var(--muted);
          font-size: 13px;
          font-weight: 700;
          transition: all 0.2s ease;
        }
        .filter-button.active {
          background: var(--teal);
          border-color: var(--teal);
          color: #fff;
          box-shadow: 0 10px 22px rgba(37,99,235,0.18);
        }
        .filter-select,
        .filter-input {
          width: 100%;
          min-height: 44px;
          border-radius: 8px;
          border: 1px solid var(--border);
          background: #fff;
          color: var(--text);
          padding: 0 14px;
          font-size: 14px;
          outline: none;
        }
        .filter-input:focus,
        .filter-select:focus {
          border-color: rgba(37,99,235,0.55);
          box-shadow: 0 0 0 3px rgba(37,99,235,0.12);
        }
        .featured-case {
          display: grid;
          grid-template-columns: 1.08fr 0.92fr;
          gap: 0;
          overflow: hidden;
          border: 1px solid var(--border);
          border-radius: 8px;
          background: #fff;
          box-shadow: 0 22px 60px -34px rgba(15,23,42,0.45);
        }
        .portfolio-grid {
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 20px;
        }
        .project-card {
          overflow: hidden;
          background: #fff;
          border: 1px solid var(--border);
          border-radius: 8px;
          transition: transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease;
        }
        .project-card:hover {
          transform: translateY(-5px);
          border-color: rgba(37,99,235,0.28);
          box-shadow: 0 22px 48px -30px rgba(15,23,42,0.48);
        }
        .project-image-wrap {
          position: relative;
          aspect-ratio: 16 / 10;
          overflow: hidden;
          background: #e2e8f0;
        }
        .project-image {
          width: 100%;
          height: 100%;
          display: block;
          object-fit: cover;
          transition: transform 0.35s ease;
        }
        .project-card:hover .project-image { transform: scale(1.035); }
        .project-shade {
          position: absolute;
          inset: 0;
          background: linear-gradient(180deg, rgba(15,23,42,0.05), rgba(15,23,42,0.55));
        }
        .project-meta {
          position: absolute;
          left: 14px;
          right: 14px;
          bottom: 14px;
          display: flex;
          justify-content: space-between;
          gap: 10px;
          color: #fff;
          font-size: 12px;
          font-family: var(--font-m);
          font-weight: 800;
        }
        .detail-label {
          color: var(--text);
          font-family: var(--font-m);
          font-size: 12px;
          font-weight: 800;
          letter-spacing: 1px;
          text-transform: uppercase;
          margin-bottom: 12px;
        }
        .process-grid {
          display: grid;
          grid-template-columns: repeat(4, minmax(0, 1fr));
          gap: 16px;
        }
        .process-card {
          border: 1px solid var(--border);
          border-radius: 8px;
          background: #fff;
          padding: 26px 22px;
        }
        .tech-marquee {
          display: flex;
          gap: 46px;
          width: max-content;
          animation: slideMarquee 24s linear infinite;
          white-space: nowrap;
        }

        @media (max-width: 980px) {
          .featured-case,
          .modal-layout { grid-template-columns: 1fr !important; }
          .portfolio-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
          .process-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
        }
        @media (max-width: 680px) {
          .portfolio-grid,
          .process-grid { grid-template-columns: 1fr; }
          .filter-row { grid-template-columns: 1fr !important; }
          .hero-title { font-size: 42px !important; }
        }
        @media (prefers-reduced-motion: reduce) {
          *, *::before, *::after { animation: none !important; transition: none !important; }
        }
      `}</style>

      <section style={{ padding: '150px 0 76px', position: 'relative', overflow: 'hidden', background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)' }}>
        <div style={{
          position: 'absolute',
          inset: 0,
          backgroundImage: 'linear-gradient(var(--border) 1px,transparent 1px),linear-gradient(90deg,var(--border) 1px,transparent 1px)',
          backgroundSize: '64px 64px',
          opacity: 0.44,
        }} />
        <div className="portfolio-shell" style={{ position: 'relative', zIndex: 1 }}>
          <div style={{ maxWidth: 850, animation: 'fadeUp 0.7s ease both' }}>
            <div className="portfolio-label">Portfolio</div>
            <h1 className="hero-title" style={{ fontFamily: 'var(--font-h)', fontSize: 'clamp(48px, 7vw, 86px)', lineHeight: 0.98, color: 'var(--text)', margin: '0 0 24px', fontWeight: 900 }}>
              Software projects built for real business operations.
            </h1>
            <p style={{ color: 'var(--muted)', fontSize: 18, lineHeight: 1.75, maxWidth: 660, marginBottom: 34 }}>
              Explore platforms we have designed and shipped across e-commerce, travel, SaaS, automation, delivery, and custom internal systems.
            </p>
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
              <Link to="/contact" className="btn-primary" style={{ padding: '15px 30px' }}>
                Start a Project -&gt;
              </Link>
              <a href="#portfolio-work" className="btn-outline" style={{ padding: '15px 28px' }}>
                Explore Work
              </a>
            </div>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
            gap: 12,
            marginTop: 52,
          }} className="process-grid">
            {[
              ['15+', 'Projects shipped'],
              ['7', 'Live client sites'],
              ['10+', 'Technology stacks'],
              ['24h', 'Proposal response'],
            ].map(([value, label]) => (
              <div key={label} style={{ border: '1px solid var(--border)', borderRadius: 8, background: 'rgba(255,255,255,0.82)', padding: '22px 20px' }}>
                <div style={{ fontFamily: 'var(--font-h)', fontSize: 34, fontWeight: 900, color: 'var(--text)', lineHeight: 1 }}>{value}</div>
                <div style={{ marginTop: 8, color: 'var(--muted)', fontFamily: 'var(--font-m)', fontSize: 12 }}>{label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="portfolio-shell" style={{ padding: '74px 5% 26px' }}>
        <div className="featured-case">
          <div style={{ minHeight: 420, background: '#e2e8f0' }}>
            <img src={featured.thumbnail} alt={featured.title} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
          </div>
          <div style={{ padding: 'clamp(28px, 5vw, 52px)', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <div className="portfolio-label">Featured Case</div>
            <h2 style={{ fontFamily: 'var(--font-h)', fontSize: 'clamp(32px, 5vw, 54px)', lineHeight: 1, color: 'var(--text)', margin: '0 0 18px', fontWeight: 900 }}>
              {featured.title}
            </h2>
            <p style={{ color: 'var(--muted)', fontSize: 16, lineHeight: 1.75, marginBottom: 24 }}>
              {featured.desc}
            </p>
            <div style={{ display: 'grid', gap: 10, marginBottom: 28 }}>
              {featured.results.map((result) => (
                <div key={result} style={{ display: 'flex', gap: 10, color: 'var(--text)', fontSize: 14 }}>
                  <span style={{ color: featured.color, fontWeight: 900 }}>-</span>
                  <span>{result}</span>
                </div>
              ))}
            </div>
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
              <button type="button" onClick={() => setSelectedProject(featured)} className="btn-primary" style={{ padding: '13px 24px' }}>
                View Details
              </button>
              <a href={featured.liveUrl} target="_blank" rel="noreferrer" className="btn-outline" style={{ padding: '13px 22px' }}>
                Visit Live
              </a>
            </div>
          </div>
        </div>
      </section>

      <section id="portfolio-work" className="portfolio-shell" style={{ padding: '72px 5% 96px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', gap: 24, flexWrap: 'wrap', marginBottom: 28 }}>
          <div>
            <div className="portfolio-label">Selected Work</div>
            <h2 style={{ fontFamily: 'var(--font-h)', fontSize: 'clamp(30px, 4.5vw, 52px)', lineHeight: 1.05, color: 'var(--text)', margin: 0, fontWeight: 900 }}>
              Browse by project type, stack, or keyword.
            </h2>
          </div>
          <div style={{ color: 'var(--muted)', fontFamily: 'var(--font-m)', fontSize: 13 }}>
            {filteredProjects.length} of {PROJECTS.length} projects
          </div>
        </div>

        <div style={{ border: '1px solid var(--border)', borderRadius: 8, background: '#fff', padding: 18, marginBottom: 26 }}>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 14 }}>
            {CATEGORIES.map((item) => (
              <button
                key={item}
                type="button"
                className={`filter-button ${category === item ? 'active' : ''}`}
                onClick={() => setCategory(item)}
              >
                {item}
              </button>
            ))}
          </div>
          <div className="filter-row" style={{ display: 'grid', gridTemplateColumns: '1fr 260px', gap: 12 }}>
            <input
              value={search}
              onChange={(event) => setSearch(event.target.value)}
              placeholder="Search project, industry, or technology"
              className="filter-input"
            />
            <select value={stack} onChange={(event) => setStack(event.target.value)} className="filter-select">
              {STACKS.map((item) => (
                <option key={item} value={item}>{item === 'All' ? 'All technologies' : item}</option>
              ))}
            </select>
          </div>
        </div>

        {filteredProjects.length > 0 ? (
          <div className="portfolio-grid">
            {filteredProjects.map((project) => (
              <ProjectCard key={project.id} project={project} onSelect={setSelectedProject} />
            ))}
          </div>
        ) : (
          <div style={{ textAlign: 'center', border: '1px solid var(--border)', borderRadius: 8, background: '#fff', padding: '54px 22px' }}>
            <h3 style={{ fontFamily: 'var(--font-h)', fontSize: 26, marginBottom: 10, color: 'var(--text)' }}>No matching projects</h3>
            <p style={{ color: 'var(--muted)', marginBottom: 22 }}>Try clearing filters or searching a different keyword.</p>
            <button
              type="button"
              className="btn-outline"
              onClick={() => {
                setCategory('All');
                setStack('All');
                setSearch('');
              }}
            >
              Clear Filters
            </button>
          </div>
        )}
      </section>

      <section style={{ padding: '82px 0', background: '#fff', borderTop: '1px solid var(--border)', borderBottom: '1px solid var(--border)' }}>
        <div className="portfolio-shell">
          <div style={{ textAlign: 'center', marginBottom: 42 }}>
            <div className="portfolio-label" style={{ justifyContent: 'center' }}>Delivery Method</div>
            <h2 style={{ fontFamily: 'var(--font-h)', fontSize: 'clamp(30px, 4.5vw, 48px)', lineHeight: 1.08, color: 'var(--text)', margin: 0, fontWeight: 900 }}>
              Every project follows a clear build path.
            </h2>
          </div>
          <div className="process-grid">
            {PROCESS.map((item) => (
              <div key={item.step} className="process-card">
                <div style={{ color: 'var(--teal)', fontFamily: 'var(--font-h)', fontSize: 28, fontWeight: 900, marginBottom: 18 }}>{item.step}</div>
                <h3 style={{ fontFamily: 'var(--font-h)', fontSize: 19, color: 'var(--text)', margin: '0 0 10px', fontWeight: 800 }}>{item.title}</h3>
                <p style={{ color: 'var(--muted)', fontSize: 14, lineHeight: 1.7 }}>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section style={{ padding: '34px 0', overflow: 'hidden', borderBottom: '1px solid var(--border)', background: 'var(--bg2)' }}>
        <div className="tech-marquee">
          {[...STACKS.filter((item) => item !== 'All'), ...STACKS.filter((item) => item !== 'All')].map((item, index) => (
            <span key={`${item}-${index}`} style={{ color: 'var(--muted)', fontFamily: 'var(--font-m)', fontSize: 13, fontWeight: 800 }}>
              {item}
            </span>
          ))}
        </div>
      </section>

      <section className="portfolio-shell" style={{ padding: '94px 5% 110px' }}>
        <div style={{
          border: '1px solid var(--border)',
          borderRadius: 8,
          background: '#0f172a',
          color: '#fff',
          padding: 'clamp(42px, 7vw, 76px)',
          display: 'grid',
          gridTemplateColumns: '1fr auto',
          gap: 28,
          alignItems: 'center',
        }} className="filter-row">
          <div>
            <div style={{ color: '#93c5fd', fontFamily: 'var(--font-m)', fontSize: 12, fontWeight: 800, textTransform: 'uppercase', marginBottom: 16 }}>Build with AxentraLab</div>
            <h2 style={{ fontFamily: 'var(--font-h)', fontSize: 'clamp(32px, 5vw, 58px)', lineHeight: 1.02, margin: '0 0 18px', fontWeight: 900 }}>
              Have a project that should be on this page next?
            </h2>
            <p style={{ color: '#cbd5e1', fontSize: 16, lineHeight: 1.7, maxWidth: 620 }}>
              Tell us what you need. We will map the scope, estimate the timeline, and recommend the fastest reliable path to launch.
            </p>
          </div>
          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'flex-start' }}>
            <Link to="/contact" className="btn-primary" style={{ padding: '15px 28px', background: '#fff', color: '#0f172a' }}>
              Start a Project
            </Link>
            <Link to="/services" className="btn-outline" style={{ padding: '15px 26px', color: '#fff', borderColor: 'rgba(255,255,255,0.36)' }}>
              See Services
            </Link>
          </div>
        </div>
      </section>

      <ProjectModal project={selectedProject} onClose={() => setSelectedProject(null)} />
    </div>
  );
}

